import memoize from 'memoize-one';
import { DriverCarData, Location } from '../../@types';
import MapTypes from '../../@types/redux/store/MapTypes';
import DeeplinkTypes from '../../@types/redux/store/DeeplinkTypes';
import { mapContentFromDeeplink } from '../store/ui/deeplink/helpers';
import { gasStations } from '../../data';
import { distanceBetweenLocationsInKm } from '../../helpers/distanceBetweenLocationsInKm';
import { locationFromString } from '../../helpers/locationFromString';
import { isRentalOngoing } from '../../helpers/rentalHelpers';

type Dispatch = (action: any) => any;
type GetState = () => any;

export const memorizedSortedCars = memoize(
  (cars: Array<DriverCarData>, userLocation: Location) =>
    cars.sort((l, r) =>
      distanceBetweenLocationsInKm(
        locationFromString(l.position),
        userLocation
      ) >
      distanceBetweenLocationsInKm(locationFromString(r.position), userLocation)
        ? 1
        : -1
    )
);

const setMapContentRaw = (
  mapType: any | null | undefined,
  cardType: string,
  id: string[] | string | null | undefined = null
) => ({
  type: MapTypes.SET_MAP_CONTENT,
  payload: { mapType, cardType, id },
});

export const updateMapContentWithCar =
  (carId: string) => (dispatch: Dispatch, getState: GetState) => {
    const { rentalData } = getState().userData.rental;
    if (rentalData && isRentalOngoing(rentalData)) return;

    const { content } = getState().ui.map;
    const availableCar = getState().carsSearch.availableCars[carId];

    if (availableCar) {
      dispatch(
        setMapContentRaw('selectedAvailableCar', content.cardType, carId)
      );
    }

    const unavailableCar = getState().carsSearch.unavailableCars[carId];

    if (unavailableCar) {
      dispatch(
        setMapContentRaw('selectedUnavailableCar', content.cardType, carId)
      );
    }
  };

export const resolveInitialMapContent =
  // eslint-disable-next-line no-unused-vars


    (_userLocation: Location | null | undefined) =>
    (dispatch: Dispatch, getState: GetState) => {
      const { rentalData } = getState().userData.rental;
      const { user } = getState().userData.user;

      const { availableCars, unavailableCars } = getState().carsSearch;
      const { deeplinkUrl } = getState().ui.deeplink;

      if (rentalData === null) {
        if (deeplinkUrl.length > 0 && deeplinkUrl.includes('/map?id')) {
          const mapContent = mapContentFromDeeplink(
            deeplinkUrl,
            availableCars,
            unavailableCars,
            gasStations
          );

          if (mapContent) {
            dispatch(
              setMapContentRaw(
                mapContent.mapType,
                mapContent.cardType,
                mapContent.id
              )
            );
          } else {
            // clear map content in case car is not found
            dispatch({
              type: MapTypes.SET_MAP_CONTENT,
              payload: {
                mapType: null,
                cardType: user ? 'none' : 'signUp',
                id: null,
              },
            });
          }

          dispatch({
            type: DeeplinkTypes.SET_DEEPLINK_URL,
            payload: { deeplinkUrl: '' },
          });
        }
      }
    };
